<template>
  <generic-configuration-card v-model="googleAnalytics" :disabled="disabled" title="Google Analytics">
    <template #description>
      O Google Analytics é uma ferramenta gratuita de análise de dados oferecida pelo Google que permite a análise de acessos e navegação dos usuários no seu
      site. Para utiliza-lo, basta inserir o codigo de acompanhamento do analytics aqui. Para saber mais confira a
      <a class="link" target="_blank" href="https://support.google.com/analytics/answer/9304153?hl=pt">documentação da Google</a>.
    </template>
  </generic-configuration-card>
</template>

<script>
import GenericConfigurationCard from './GenericConfigurationCard.vue'

export default {
  name: 'AdsGoogleAnalyticsConfiguration',
  components: {
    GenericConfigurationCard,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    localGoogleAnalytics: '',
  }),
  computed: {
    googleAnalytics: {
      get() {
        return this.localGoogleAnalytics
      },
      set(value) {
        this.localGoogleAnalytics = value
        this.$emit('input', value)
      },
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.localGoogleAnalytics = newVal
      },
      immediate: true,
    },
  },
}
</script>
